export const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms));

export async function retry<T>(
  fn: () => Promise<T>,
  retries: number,
): Promise<T> {
  let attempt = 0;
  while (true) {
    try {
      return await fn();
    } catch (err) {
      if (attempt >= retries) throw err;
      const delay = Math.pow(2, attempt) * 100;
      await sleep(delay);
      attempt++;
    }
  }
}
